import { Link, router } from "@inertiajs/react";
import type Category from "@/types/serializers/Category";
import { useFlashToast } from "@/hooks/useFlashToast";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { ArrowLeft, Pencil, Trash2 } from "lucide-react";

type Props = {
  category: Category;
  flash?: { notice?: string; alert?: string };
};

export default function CategoriesShow({ category, flash }: Props) {
  useFlashToast(flash);

  function handleDelete() {
    if (!confirm("Are you sure you want to delete this category?")) return;
    router.delete(`/categories/${category.id}`);
  }

  return (
    <div className="py-8 px-4">
      <div className="mx-auto max-w-xl space-y-6">
        <Button variant="ghost" size="sm" asChild>
          <Link href="/categories">
            <ArrowLeft className="size-4" />
            Back to categories
          </Link>
        </Button>

        <Card>
          <CardHeader>
            <CardTitle>{category.name}</CardTitle>
            <CardDescription>Category details</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-1">
              <p className="text-sm font-medium text-muted-foreground">Name</p>
              <p className="text-sm">{category.name || <span className="italic text-muted-foreground">—</span>}</p>
            </div>
            <div className="space-y-1">
              <p className="text-sm font-medium text-muted-foreground">Description</p>
              <p className="text-sm">{category.description || <span className="italic text-muted-foreground">No description</span>}</p>
            </div>
            <div className="flex gap-2 pt-2">
              <Button size="sm" asChild>
                <Link href={`/categories/${category.id}/edit`}>
                  <Pencil className="size-4" />
                  Edit
                </Link>
              </Button>
              <Button size="sm" variant="destructive" onClick={handleDelete}>
                <Trash2 className="size-4" />
                Delete
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
